import { LazyLoad } from 'app/utils';

export const NotificationFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.NotificationFormPage,
);
